<template>
  <div class="SignUpMFAComponent">
    <Form @submit="loginMFA" :validation-schema="schema" v-slot="{ meta }">
      <CardComponent class="form-loginMFA" :width="'960px'" :height="'auto'">
        <TitleComponent
          class="form-loginMFA_title fitContent"
          :hasUnderLine="true"
        >
          <template v-slot:content>多要素認証でログインします</template>
        </TitleComponent>
        <p class="form-loginMFA_description">
          送信された認証コードを入力してください。
        </p>

        <div class="form-loginMFA_inputGroups">
          <div class="form-loginMFA-inputGroup"></div>
          <div class="form-loginMFA-inputGroup">
            <InputComponent
              name="code"
              placeholder="認証コードを入力"
              maxlength="6"
              inputFilter="number"
              @trigle-change="errorDetail = null"
            />
          </div>
        </div>
        <div class="memo">
          <span>※認証コードを入力し、セキュアにログインします。</span>
          <span
            >※一度認証すると、一定の期間、認証コードの入力は不要になります。</span
          >
        </div>
        <ErrorDetailComponent v-if="errorDetail" :errorDetail="errorDetail" />
        <div class="form-loginMFA-action-group">
          <ButtonComponent
            buttonType="submit"
            width="160px"
            :disabled="!(meta.valid && meta.dirty)"
          >
            次へ
          </ButtonComponent>
        </div>
        <LinkComponent :link="$domain.HELP_CONTENT_LINK['2-1-c']">
          <span class="d-flex align-center justify-center black">
            <i class="icon icon-help"></i>
            操作方法がご不明な場合
          </span>
        </LinkComponent>
        <InquiryBannerComponent class="mb-5" />
      </CardComponent>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import LoginService from "@/services/login.service";
import { mapState } from "vuex";
import { loginMFASchema } from "@/validations/schemas/loginMFASchema";
import { STATUS } from "@/globals/enums";

export default {
  name: "SignUpMFAComponent",
  components: {
    Form,
  },
  computed: mapState({
    tempUser: (state) => state.settings.tempUser,
  }),
  data: () => ({
    loginService: new LoginService(),
    schema: loginMFASchema,
    errorDetail: null,
  }),
  methods: {
    async loginMFA(data) {
      this.$store.dispatch("global/updateLoadingStatus", true);
      const result = await this.loginService.signIn(
        this.tempUser.emailAddress,
        this.tempUser.tempPassword,
        null,
        data.code
      );
      this.$store.dispatch("global/updateLoadingStatus", false);
      if (result?.status === STATUS.ERROR && result?.response?.detail) {
        this.errorDetail = result.response.detail;
      }
    },
    async cancel(e) {
      e.preventDefault();
      await this.loginService.logout();
    },
    async resetMFA() {
      await this.$router.push({ name: "ResetMFAComponent" });
    },
  },
};
</script>

<style scoped lang="scss">
.SignUpMFAComponent {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .form {
    &-loginMFA {
      padding: 30px 40px;
      margin: 40px 0;

      display: flex;
      flex-direction: column;
      align-items: center;
      &_title {
        font-size: 20px;
        font-weight: 500;
      }
      &_description {
        font-size: 14px;
        font-weight: 500;
        margin: 20px 0 0;
      }
      &_inputGroups {
        display: flex;
        flex-direction: column;
        gap: 40px;
        padding: 0 220px 40px;
      }
      &-inputGroup {
        display: flex;
        gap: 30px;
        align-items: center;
        justify-content: space-between;
        &_title {
          font-size: 14px;
          font-weight: bold;
          color: #7c8185;
        }
        .InputComponent {
          margin: 0;
        }
      }
      &-action-group {
        display: flex;
        gap: 20px;
        font-size: 18px;
        font-weight: bold;
      }
      &-resetMFA {
        cursor: pointer;
        display: inline-flex;
        color: var(--color-black-text);
        font-weight: 500;
        margin-top: 15px;
        .icon-ico_lock {
          font-size: 25px;
          margin-right: 5px;
        }
      }
    }
  }
  .memo {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 12px;
    font-weight: normal;
    color: #7c8185;
    margin-bottom: 27px;
  }
}
@media only screen and (max-width: $mobile-breakpoint) {
  .SignUpMFAComponent {
    height: 100%;
    display: block;
    .v-card {
      width: 100% !important;
      height: 100% !important;
    }
    form {
      height: 100%;
    }
    .form {
      &-loginMFA {
        padding: 30px 20px;
        margin: 0;

        &_inputGroups {
          width: 100%;
          gap: 40px;
          padding: 0;
          margin-bottom: 40px;
        }
        &-inputGroup {
          display: flex;
          gap: 30px;
          align-items: center;
          justify-content: space-between;
          &_title {
            font-size: 14px;
            // font-weight: bold;
            color: #7c8185;
          }
          .InputComponent {
            margin: 0;
            width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
